import { BreadcrumbLevel } from '@heimdallr-sdk/types';
var Breadcrumb = (function () {
    function Breadcrumb(options) {
        if (options === void 0) { options = {}; }
        this.maxBreadcrumbs = options.maxBreadcrumbs || 5;
        this.stack = [];
    }
    Breadcrumb.prototype.unshift = function (data) {
        if (!data.time) {
            data.time = new Date().getTime();
        }
        if (!data.level) {
            data.level = BreadcrumbLevel.INFO;
        }
        if (this.stack.length >= this.maxBreadcrumbs) {
            this.pop();
        }
        this.stack.unshift(data);
        this.stack.sort(function (a, b) { return b.time - a.time; });
        return this.stack;
    };
    Breadcrumb.prototype.pop = function () {
        return this.stack.pop() !== undefined;
    };
    Breadcrumb.prototype.clear = function () {
        this.stack = [];
    };
    Breadcrumb.prototype.getStack = function () {
        return this.stack.slice(0);
    };
    return Breadcrumb;
}());
export { Breadcrumb };
